import dayjs from "dayjs";

// ─── Filter Value Extractor ─────────────────────────────────────────────────

export const extractFilterValue = (v: any): string | undefined => {
  if (!v) return undefined;
  if (typeof v === "object" && v?.value) return v.value;
  return typeof v === "string" ? v : undefined;
};

// ─── Date Range Resolver ────────────────────────────────────────────────────

export const resolveDateRange = (
  preset?: string,
  customStart?: string,
  customEnd?: string
): { startDate?: string; endDate?: string } => {
  if (!preset) return {};

  if (preset === "CUSTOM_RANGE") {
    return {
      startDate: customStart ? dayjs(customStart).startOf("day").toISOString() : undefined,
      endDate: customEnd ? dayjs(customEnd).endOf("day").toISOString() : undefined,
    };
  }

  const now = dayjs();
  let start: dayjs.Dayjs;
  let end: dayjs.Dayjs = now.endOf("day");

  switch (preset) {
    case "TODAY":
      start = now.startOf("day");
      break;
    case "YESTERDAY":
      start = now.subtract(1, "day").startOf("day");
      end = now.subtract(1, "day").endOf("day");
      break;
    case "THIS_WEEK":
      start = now.startOf("week");
      break;
    case "LAST_7_DAYS":
      start = now.subtract(7, "day").startOf("day");
      break;
    case "THIS_MONTH":
      start = now.startOf("month");
      break;
    case "LAST_MONTH":
      start = now.subtract(1, "month").startOf("month");
      end = now.subtract(1, "month").endOf("month");
      break;
    case "LAST_3_MONTHS":
      start = now.subtract(3, "month").startOf("day");
      break;
    case "LAST_6_MONTHS":
      start = now.subtract(6, "month").startOf("day");
      break;
    case "LAST_90_DAYS":
      start = now.subtract(90, "day").startOf("day");
      break;
    case "THIS_YEAR":
      start = now.startOf("year");
      break;
    default:
      return {};
  }

  return {
    startDate: start.toISOString(),
    endDate: end.toISOString(),
  };
};
